<template>
  <BaseLayout>
    
    <div class="container mx-auto py-8 px-4">
      <h1 class="text-2xl font-bold mb-4">Meta Tags Voorbeeld</h1>
      <p class="mb-4">Deze pagina toont server-side meta via GlobalMetaTags in BaseLayout.</p>
      
      <div class="bg-gray-100 p-4 rounded mb-6">
        <h2 class="font-bold mb-2">Huidige Meta Tags:</h2>
        <pre class="overflow-auto p-2 bg-gray-200 rounded text-sm">{{ JSON.stringify($page.props.meta, null, 2) }}</pre>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
export default {
  // Empty component with default export
}
</script>
